export default "__VITE_ASSET__d0f010da__"